import { render, staticRenderFns } from "./TeremDefendStatistics.vue?vue&type=template&id=f94f5fa2&scoped=true&"
import script from "./TeremDefendStatistics.vue?vue&type=script&lang=js&"
export * from "./TeremDefendStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TeremDefendStatistics.vue?vue&type=style&index=0&id=f94f5fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94f5fa2",
  null
  
)

export default component.exports